module.exports = __webpack_public_path__ + "img/text-blue.84829343.svg";